import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';

import * as MediaUpload from './MediaUpload';

export type V = {
  '@id': string;
  '@type': 'MetricMeal';
  id: string;
  date: string;
  meal: string;
  hungerFullnessLevel: number | null;
  items: Array<{
    '@id': string;
    '@type': 'MetricMealItem';
    id: string;
    foodItem: string | null;
    serving: number | null;
    customMealName: string | null;
    description: string | null;
    image: MediaUpload.BaseView | null;
  }>;
};

export type V_Macronutrient = {
  '@id': string;
  '@type': 'MetricMeal';
  date: string;
  carbs: number;
  protein: number;
  fat: number;
};

export type V_MineByDate = {
  '@id': string;
  '@type': 'MetricMeal';
  id: string;
  meal: string;
  hungerFullnessLevel: number | null;
  items: Array<{
    '@id': string;
    '@type': 'MetricMealItem';
    id: string;
    foodItem: {
      '@id': string;
      '@type': 'FoodItem';
      name: string;
    } | null;
    serving: number | null;
    customMealName: string | null;
  }>;
};

export type V_UserSub = {
  '@id': string;
  '@type': 'MetricMeal';
  date: string;
  meals: Array<{
    '@id': string;
    '@type': 'MetricMeal';
    meal: string;
    hungerFullnessLevel: number | null;
    items: Array<{
      '@id': string;
      '@type': 'MetricMealItem';
      foodItem: {
        '@id': string;
        '@type': 'FoodItem';
        name: string;
        unit: string;
      } | null;
      serving: number | null;
      customMealName: string | null;
      description: string | null;
      image: MediaUpload.BaseView | null;
    }>;
  }>;
  waterIntake: {
    '@id': string;
    '@type': 'MetricWaterIntake';
    amount: number;
  } | null;
};

export type W_Create = {
  date: string;
  meal: string;
  hungerFullnessLevel: number | null;
  items: Array<{
    foodItem: string | null;
    serving: number | null;
    customMealName: string | null;
    description: string | null;
    image: string | null;
  }>;
};

export type W_Update = {
  hungerFullnessLevel: number | null;
  items: Array<{
    serving: number | null;
    customMealName: string | null;
    description: string | null;
    image: string | null;
  }>;
};

export function useReadCollectionByDate(date: string, options?: ReadConfig) {
  return useApiRead<HydraCollection<V_MineByDate>>(
    `/my-meals/by-date/${date}`,
    options,
  );
}

export function useReadCollectionMacronutrientsStartDateEndDate(
  id: string,
  startDate: string,
  endDate: string,
  options?: ReadConfig,
) {
  return useApiRead<HydraCollection<V_Macronutrient>>(
    `/users/${id}/macronutrients/${startDate}/${endDate}`,
    options,
  );
}

export function useReadCollectionMetricMealsStartDateEndDate(
  id: string,
  startDate: string,
  endDate: string,
  options?: ReadConfig,
) {
  return useApiRead<HydraCollection<V_UserSub>>(
    `/users/${id}/metric-meals/${startDate}/${endDate}`,
    options,
  );
}
